import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const maxtrcp4530 = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_MaxTempJuly/MapServer/8",
    title: 'Max Temp July Change until 2030',
    opacity: 0.4,
    oraId: 'maxtrcp4530',
  })